import { CommonModule } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { User } from '../../../store/auth/auth.state'
import { UserService } from '../../../services/user.service'
import { environment } from '../../../../environments/environment'
import { selectOffices } from '../../../store/office/office.reducer'
import { Store } from '@ngrx/store'
import { Observable, Subject } from 'rxjs'
import { Office } from '../../../store/office/office.state'
import { UtilsService } from '../../../services/utils.service'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { StringifyOptions } from 'node:querystring'
import { Designation } from '../../../store/designation/designation.state'
import { PaginationComponent } from '../template/pagination/pagination.component'
import { eps } from '../../../services/url.service'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'

export interface TeamMember {
  id: string
  firstName: string
  lastName: string
  email: string
  mobile: StringifyOptions
  designation: Designation
  designationName: string
  disabled: boolean
  joiningDate: string | Date
  picture?: string
  manager?: {
    id: string
    firstName: string
    lastName: string
  }

  reqManager?: {
    id: string
    firstName: string
    lastName: string
  }
  showInitials?: boolean
}

@Component({
  selector: 'app-team-members',
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationComponent,
    HasPermissionDirective
  ],
  templateUrl: './team-members.component.html',
  styleUrl: './team-members.component.scss'
})
export class TeamMembersComponent implements OnInit {
  public apiEndpoint = environment.apiBaseUrl
  private store = inject(Store)
  private fetchTrigger$ = new Subject<void>()
  teamMembers: User[] = []
  offices$!: Observable<Office[]>
  teamMemberList: TeamMember[] = []
  eps = eps
  totalCount = 0
  currentPage = 1
  pageLimit = 10
  search = ''
  pageLastRecord = 0

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private utilService: UtilsService
  ) {
    this.offices$ = this.store.select(selectOffices)
  }

  ngOnInit(): void {
    const employeeId = this.route.snapshot.paramMap.get('id')
    this.loadTeamMembers(employeeId)
  }

  getDashboardRoute(): string {
    return this.utilService.getDashboardRoute()
  }

  onSearchChange(value: string) {
    this.search = value
    this.currentPage = 1
    // this.fetchTrigger$.next()
    this.loadTeamMembers(this.route.snapshot.paramMap.get('id'))
  }

  goTopPage(page: number) {
    this.currentPage = page
    // this.fetchTrigger$.next()
    this.loadTeamMembers(this.route.snapshot.paramMap.get('id'))
  }

  getInitials(firstName = '', lastName = ''): string {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  loadTeamMembers(employeeId: string | null) {
    if (!employeeId) return

    this.userService
      .getTeamMembersOfEmployee(employeeId, this.search, this.currentPage, this.pageLimit)
      .subscribe({
        next: res => {
          this.teamMemberList = res.teamMembers.map((member: TeamMember) => ({
            ...member,
            showInitials: !member.picture
          }))
          this.totalCount = res.totalCount
          // this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
          // this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
        },
        error: err => {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch team members:', err)
        }
      })
  }

  // loadTeamMembers(employeeId: string | null) {
  //   if (!employeeId) return
  //   const params = ''
  //   const page = 1
  //   const limit = 20
  //   this.userService.getTeamMembersOfEmployee(employeeId, params, page, limit).subscribe({
  //     next: res => {
  //       this.teamMembers = res
  //     },
  //     error: err => {
  //       // eslint-disable-next-line no-console
  //       console.error('Failed to fetch team members:', err)
  //     }
  //   })
  // }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    const employeeId = this.route.snapshot.paramMap.get('id')
    this.loadTeamMembers(employeeId) // Load employees with new page limit
  }
}
